import { Tags } from '@/types/tag.types';
import api from './api';

export const handleCreateTag = async (params: any) => api.post<any>('Tags/NewTag', { ...params });

export const handleGetTags = async () => api.get<Tags.Request>(`Tags/ListTags`, {});
